import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule, RouterOutlet } from '@angular/router';
import { doc, Firestore, setDoc } from '@angular/fire/firestore';
import { Observable, Subscription } from 'rxjs';
import { AdminAuthComponent } from '../../auth/admin-auth-component/admin-auth-component';
import { Tournament } from '../shared/tournament';
import { TournamentCategory } from '../shared/tournament-category';
import { OpenSquashService } from '../shared/services/open-squash-service';

@Component({
  selector: 'app-i-valida-ant-2026-component',
  imports: [RouterModule, RouterOutlet, CommonModule, MatButtonModule],
  templateUrl: './i-valida-ant-2026-component.html',
  styleUrl: './i-valida-ant-2026-component.scss',
})
export class IValidaAnt2026Component {
  private openSquashService = inject(OpenSquashService);
  private dialog = inject(MatDialog);
  private firestore = inject(Firestore);

  torneoCreado = false;

  tournament!: Tournament;
  categories: TournamentCategory[] = [];
  esAdmin$!: Observable<boolean>;
  tournamentSubscription!: Subscription;

  ngOnInit(): void {
    this.esAdmin$ = this.openSquashService.esAdmin$;
    this.openSquashService.setTournament('i-valida-ant-2026');
    this.tournamentSubscription = this.openSquashService.tournament$.subscribe(
      (tournament) => {
        this.tournament = tournament;
        this.categories = tournament.categories.sort(
          (a, b) => a.categoryOrder - b.categoryOrder
        );
      }
    );
  }

  authAdmin() {
    this.dialog
      .open(AdminAuthComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.openSquashService.setAsAdmin(true);
        }
      });
  }

  logout() {
    this.openSquashService.setAsAdmin(false);
  }

  async crearTorneo() {
    const categorias = [
      'expertos', 'tercera', 'cuarta', 'quinta',
      'sexta', 'juvenil', 'infantilA', 'infantilB', 'damas', 'novatos'
    ];

    const tournament = {
      name: 'I Válida Departamental 2026',
      categories: categorias.map((cat, i) => ({
        category: cat,
        categoryOrder: i + 1,
        groups: [{ name: 'A', players: [] }],
        players: [],
        finals: {},
        hasQuarterFinals: false,
        hasSemiFinals: false,
        hasFinal: false,
      })),
    };

    const ref = doc(this.firestore, 'tournament/i-valida-ant-2026');
    await setDoc(ref, tournament);
    this.torneoCreado = true;
    console.log('Torneo i-valida-ant-2026 creado en Firestore');
    this.openSquashService.setTournament('i-valida-ant-2026');
    this.tournamentSubscription = this.openSquashService.tournament$.subscribe(
      (tournament) => {
        this.tournament = tournament;
        this.categories = tournament.categories.sort(
          (a, b) => a.categoryOrder - b.categoryOrder
        );
      }
    );
  }

  ngOnDestroy(): void {
    this.tournamentSubscription.unsubscribe();
  }
}
